module.exports = __webpack_public_path__ + "files/4a3cb9d8e2e76de919eba6d76645e3b5.png";